import { endPoint } from "constants/server/api";
import { createFetchMaster } from "../../utils/fetchFactory";
import { createSlicePrototype } from "../../utils/sliceFactory";
var getAllBranchPaymentChannelSlice = createSlicePrototype({
    name: "getAllBranchPaymentChannel"
});
export var getAllBranchPaymentChannel = createFetchMaster({
    actions: getAllBranchPaymentChannelSlice.actions,
    config: {
        method: "get",
        url: endPoint.BRANCH_PAYMENT_CHANNEL
    }
});
var _getAllBranchPaymentChannelSlice_actions = getAllBranchPaymentChannelSlice.actions;
export var fetchData = _getAllBranchPaymentChannelSlice_actions.fetchData, fetchDataSuccess = _getAllBranchPaymentChannelSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllBranchPaymentChannelSlice_actions.fetchDataFailure, resetState = _getAllBranchPaymentChannelSlice_actions.resetState;
export default getAllBranchPaymentChannelSlice.reducer;
